import { ChartType } from '../Chart';
import { Series, Point } from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

export interface MarkerProps {
  chartRef: {
    current: HighchartsReact.RefObject | null;
  };
  chartType: ChartType['type'];
  hideMarkers: boolean;
}

// Function to only show every X markers (determined by `maxPointsBeforeSelectiveHiding` below)
export const removeExcessMarkers = ({
  chartRef,
  chartType,
  hideMarkers,
}: MarkerProps) => {
  if (
    chartRef.current == null ||
    chartRef.current.chart == null ||
    hideMarkers
  ) {
    return;
  }

  // Max points a series can have before the below function takes effect.
  const maxPointsBeforeSelectiveHiding = 100;

  const chartInstance: Highcharts.Chart = chartRef.current.chart;
  if (chartType === 'line' && chartInstance.series.length > 0) {
    for (let i = 0; i < chartInstance.series.length; i++) {
      const currentSeries: Series = chartInstance.series[i];
      const points: Point[] = currentSeries.points;
      if (points.length === 0 || points.length < maxPointsBeforeSelectiveHiding)
        continue;
      for (let j = 1; j < points.length; j++) {
        // Total number of points desired on the chart.
        // Actual number shown may be slightly off due to divisibility of number of points,
        // and the fact that we want a marker on the first and last points always.
        const density = 10;
        const point = points[j];
        if (j % Math.floor(points.length / density) > 0 && j < points.length) {
          // Can't seem to find the correct typing for `points[j]`
          // under which `graphic` exists, but the code works.
          // @ts-ignore
          point.graphic.hide();
        }
      }
    }
  }
};
